import '@/bootstrap';
import { Message, MessageBox } from 'element-ui';
import { getToken } from '@/utils/auth';
import store from '@/store';

// Create axios instance
const service = window.axios.create({
  baseURL: '/api', // http://sciagri.test/api http://localhost:8000 /api
  // timeout: 10000000, // Request timeout
});

// Request intercepter : envoyer le token Sanctum pour les routes protégées
service.interceptors.request.use(
  (config) => {
    const fromCookie = getToken();
    const fromStore = store.state.user && store.state.user.token;
    const token = (fromCookie && String(fromCookie).length > 1) ? fromCookie : fromStore;
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  (response) => {
    // if (response.headers.authorization) {
    //   setLogged(response.headers.authorization);
    //   response.data.token = response.headers.authorization;
    // }
    const res = response.data;
    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      // to re-login
      MessageBox.confirm(
        'You have been logged out, you can cancel to stay on this page, or log in again',
        'Confirm logout',
        {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload();
        });
      });
    }
    return response.data;
  },
  (error) => {
    if (error.code === 'ERR_CANCELED' || error.name === 'CanceledError' || (error.message && error.message.toLowerCase().includes('abort'))) {
      return Promise.reject(error);
    }
    // const res = error.response.data;
    if (error.response && error.response.data && error.response.data.message === 'Unauthenticated') {
      // to re-login
      MessageBox.confirm(
        'You have been logged out, you can cancel to stay on this page, or log in again',
        'Confirm logout',
        {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload();
        });
      });
    }
    if (error.response && (error.response.status === 401 || (error.response.data && error.response.data.code === 401))) {
      const path = typeof window !== 'undefined' ? (window.location.pathname || '') : '';
      const onLoginPage = path === '/login' || path.endsWith('/login');
      store.dispatch('user/resetToken').then(() => {
        if (!onLoginPage) {
          location.reload();
        }
      });
    }
    let message = error.message;
    if (error.response && error.response.data && error.response.data.errors) {
      message = error.response.data.errors;
    } else if (error.response && error.response.data && error.response.data.error) {
      message = error.response.data.error;
    } else if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message;
    }

    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
